<!-- ----------------------------------------------------------------------- -->
<!--                            Grid page header                             -->
<!-- ----------------------------------------------------------------------- -->
<div class="crm-page-header">
    <div class="list-header">
        <ng-container *ngIf="grid.isPage">
            <h2>{{ grid.title }}</h2>
            <i
                nz-icon
                class="refresh-list"
                nzType="reload"
                nz-tooltip
                nzTooltipTitle="Refresh"
                nzTheme="outline"
                (click)="load()"
            ></i>
        </ng-container>

        <nz-tag
            style="margin-left: 2rem"
            *ngIf="segment && segmentData"
            [nzColor]="'green'"
            nzMode="closeable"
            (nzOnClose)="clearSegment()"
        >
            {{ segmentData.label }}
        </nz-tag>
        <span class="spacer"></span>
        <!-- -------------------------- Selection Action --------------------------- -->
        <ng-container *ngIf="setOfCheckedId.size">
            <nz-badge [nzCount]="setOfCheckedId.size">
                <button
                    style="margin-left: 1rem"
                    nz-button
                    nzType="dashed"
                    (click)="emitSelection()"
                >
                    {{ grid.editSelectionLabel || 'Edit Selected' }}
                </button>
            </nz-badge>
        </ng-container>
        <!-- Custom Filter -->
        <ng-container *ngIf="customFilters">
            <ng-container *ngTemplateOutlet="customFilters"></ng-container>
        </ng-container>

        <!-- ---------------------------- grid actions ----------------------------- -->
        <ng-container *ngFor="let action of gridActions">
            <ng-container *ngIf="!action.disabled || !action.disabled()">
                <button
                    style="margin-left: 1rem"
                    nz-button
                    [nzType]="$any(action.theme) || 'primary'"
                    (click)="emit({ action: action.name })"
                >
                    <i nz-icon [nzType]="action.icon"> </i>
                    {{ action.title }}
                </button>
            </ng-container>
        </ng-container>
    </div>
    <nz-divider></nz-divider>
</div>

<!-- ----------------------------------------------------------------------- -->
<!--                                  Table                                  -->
<!-- ----------------------------------------------------------------------- -->
<nz-table
    #gridTable
    [nzData]="data"
    [nzLoading]="loading"
    [nzVirtualItemSize]="60"
    [nzVirtualMinBufferPx]="500"
    [nzVirtualMaxBufferPx]="1000"
    [nzFrontPagination]="!virtualScroll && !ajax"
    [nzShowPagination]="!virtualScroll"
    [nzTotal]="ajax ? total : 0"
    [nzPageSize]="ajax ? pageSize : 10"
    [nzPageIndex]="ajax ? pageIndex : 1"
    [nzShowTotal]="virtualScroll ? null : totalTemplate"
    [nzScroll]="
        virtualScroll
            ? { x: scrollX || '100%', y: virtualScrollHeight }
            : { x: scrollX || '100%' }
    "
    (nzQueryParams)="ajax ? onQueryParamsChange($event) : null"
    style="margin-top: 1rem"
>
    <thead>
        <!-- ----------------------------------------------------------------------- -->
        <!--                               Columns row                               -->
        <!-- ----------------------------------------------------------------------- -->
        <tr class="header" style="line-height: 5px">
            <!-- selection -->
            <th
                *ngIf="grid.isSelectable"
                [nzWidth]="'3rem'"
                [nzChecked]="allChecked"
                [nzIndeterminate]="indeterminate"
                (nzCheckedChange)="onAllChecked($event)"
            ></th>

            <th *ngIf="validateFn" [nzWidth]="'3rem'"></th>

            <!-- ------------------------------- columns ------------------------------- -->
            <ng-container *ngFor="let column of grid.cols">
                <ng-container *ngIf="column">
                    <th
                        [nzColumnKey]="column.name.toString()"
                        [rowspan]="column['rowspan']"
                        [nzWidth]="column.width"
                        [nzAlign]="column.align || 'center'"
                        [nzBreakWord]="true"
                        [nzSortFn]="
                            column.sortable
                                ? ajax
                                    ? true
                                    : (column.name
                                      | invoke
                                          : column.sorter ||
                                                sorters[column.type])
                                : undefined
                        "
                        [nzSortOrder]="
                            column.sortable && !ajax
                                ? column.sortOrder
                                : undefined
                        "
                        [ngStyle]="{ 'min-width': column.minWidth || '150px' }"
                    >
                        {{ column.title }}
                    </th>
                </ng-container>
            </ng-container>

            <!-- ------------------------------- actions ------------------------------- -->
            <th
                *ngIf="recordActions?.length"
                style="min-width: 100px"
                [nzAlign]="'center'"
            >
                Actions
            </th>
        </tr>

        <!-- ----------------------------------------------------------------------- -->
        <!--                               Filters row                               -->
        <!-- ----------------------------------------------------------------------- -->
        <tr [formGroup]="filterFG" class="filter" *ngIf="showFilters">
            <!-- selection -->
            <th *ngIf="grid.isSelectable"></th>

            <ng-container *ngFor="let column of grid.cols">
                <ng-container *ngIf="column">
                    <th
                        [rowspan]="column['rowspan']"
                        [nzWidth]="column.width"
                        [nzAlign]="column.align || 'center'"
                    >
                        <ng-container *ngIf="column.filter">
                            <ng-container [ngSwitch]="column.filter.type">
                                <!-- ----------------------------- text filter ----------------------------- -->
                                <ng-container *ngSwitchCase="'text'">
                                    <input
                                        nz-input
                                        [placeholder]="
                                            column.filter.placeholder || ''
                                        "
                                        [formControlName]="
                                            $any(column.filter.name) ||
                                            $any(column.name)
                                        "
                                        (keyup.enter)="applyFilters()"
                                    />
                                </ng-container>

                                <!-- ---------------------------- lookup filter ---------------------------- -->
                                <ng-container *ngSwitchCase="'lookup'">
                                    <lookup
                                        [type]="column.filter.lookup"
                                        [multi]="column.filter.multi"
                                        [formControlName]="
                                            $any(column.filter.name) ||
                                            $any(column.name)
                                        "
                                    ></lookup>
                                </ng-container>

                                <!-- ---------------------------- select filter ---------------------------- -->
                                <ng-container *ngSwitchCase="'select'">
                                    <nz-select
                                        nzAllowClear
                                        nzShowSearch
                                        style="width: 100%"
                                        [formControlName]="
                                            $any(column.filter.name) ||
                                            $any(column.name)
                                        "
                                    >
                                        <nz-option
                                            *ngFor="
                                                let option of column.filter
                                                    .options
                                            "
                                            [nzValue]="option.value"
                                            [nzLabel]="option.label"
                                        >
                                        </nz-option>
                                    </nz-select>
                                </ng-container>

                                <!-- ---------------------------- status filter ---------------------------- -->
                                <ng-container *ngSwitchCase="'status'">
                                    <nz-select
                                        nzAllowClear
                                        nzShowSearch
                                        style="width: 100%"
                                        [formControlName]="
                                            $any(column.filter.name) ||
                                            $any(column.name)
                                        "
                                    >
                                        <nz-option
                                            *ngFor="
                                                let status of column.filter
                                                    .statuses | keyvalue
                                            "
                                            [nzValue]="status.key"
                                            [nzLabel]="status.value['label']"
                                        >
                                        </nz-option>
                                    </nz-select>
                                </ng-container>

                                <!-- ----------------------------- date filter ----------------------------- -->
                                <ng-container *ngSwitchCase="'date'">
                                </ng-container>

                                <!-- -------------------------- date range filter -------------------------- -->
                                <ng-container *ngSwitchCase="'date-range'">
                                    <nz-range-picker
                                        [formControlName]="
                                            $any(column.filter.name) ||
                                            $any(column.name)
                                        "
                                        [nzRanges]="column.filter.ranges"
                                    ></nz-range-picker>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </th>
                </ng-container>
            </ng-container>

            <!-- --------------------------- filters actions --------------------------- -->
            <th>
                <button
                    nz-button
                    nzType="text"
                    nzShape="circle"
                    nz-tooltip
                    nzTooltipTitle="Apply Filter"
                    (click)="applyFilters()"
                >
                    Search
                </button>
                <nz-divider nzType="vertical"></nz-divider>
                <button
                    nz-button
                    nzType="text"
                    nzShape="circle"
                    nz-tooltip
                    nzTooltipTitle="Reset Filter"
                    (click)="resetFilters()"
                >
                    Clear
                </button>
            </th>
        </tr>
    </thead>

    <!-- ----------------------------------------------------------------------- -->
    <!--                                  Data                                   -->
    <!-- ----------------------------------------------------------------------- -->
    <tbody *ngIf="showTable">
        <ng-container *ngIf="virtualScroll">
            <ng-template nz-virtual-scroll let-data let-index="index">
                <ng-container
                    *ngTemplateOutlet="
                        gridRowTpl;
                        context: { record: data, index: index }
                    "
                >
                </ng-container>
            </ng-template>
        </ng-container>
        <ng-container *ngIf="!virtualScroll">
            <ng-container *ngFor="let record of gridTable.data; index as i">
                <ng-container
                    *ngTemplateOutlet="
                        gridRowTpl;
                        context: { record: record, index: i }
                    "
                >
                </ng-container>
            </ng-container>
        </ng-container>
    </tbody>
</nz-table>

<ng-container *ngIf="showContent">
    <ng-content></ng-content>
</ng-container>

<!-- ----------------------------------------------------------------------- -->
<!--                                Total Tpl                                -->
<!-- ----------------------------------------------------------------------- -->
<ng-template #totalTemplate let-total>Total {{ total }} items</ng-template>

<!-- ----------------------------------------------------------------------- -->
<!--                                Row Tpl                                  -->
<!-- ----------------------------------------------------------------------- -->
<ng-template #gridRowTpl let-record="record" let-index="index">
    <tr
        [ngClass]="{
            'invalid-row': validationErrors[index],
            highlighted: grid.highlighted ?  (record | invoke : grid.highlighted) : false
        }"
    >
        <!-- selection -->
        <td
            *ngIf="grid.isSelectable"
            [nzDisabled]="!!validationErrors[index]"
            [nzChecked]="!!setOfCheckedId.has(record._id || index)"
            (nzCheckedChange)="onItemChecked(record._id || index, $event)"
        ></td>
        <td *ngIf="validateFn" style="font-size: 20px">
            <ng-container *ngIf="validationErrors[index]; else validTpl">
                <span
                    nz-icon
                    nzType="close-circle"
                    nzTheme="twotone"
                    [nzTwotoneColor]="'#eb2f96'"
                    nz-popover
                    nzPopoverTitle="Invalid Record"
                    [nzPopoverContent]="contentTemplate"
                ></span>
                <ng-template #contentTemplate>
                    <ul>
                        <li
                            *ngFor="
                                let item of validationErrors[index] | keyvalue
                            "
                        >
                            {{ item.key }}: {{ item.value }}
                        </li>
                    </ul>
                </ng-template>
            </ng-container>
            <ng-template #validTpl>
                <span
                    nz-icon
                    [nzType]="'check-circle'"
                    [nzTheme]="'twotone'"
                    [nzTwotoneColor]="'#52c41a'"
                ></span>
            </ng-template>
        </td>
        <ng-container *ngFor="let col of grid.cols">
            <ng-container *ngIf="col">
                <td
                    [ngClass]="{ 'invalid-cell': validationErrors[index]?.[col.name] }"
                    [nzAlign]="col.align || 'center'"
                >
                    <ng-container [ngSwitch]="col.type">
                        <!-- -------------------------------- text --------------------------------- -->
                        <ng-container *ngSwitchCase="'text'">
                            {{
                                col.render
                                    ? (record | invoke : col.render)
                                    : record[col.name] || '-'
                            }}
                            <div *ngIf="col.subtext" class="sub-text">
                                {{ record | invoke : col.subtext }}
                            </div>
                        </ng-container>

                        <!-- -------------------------------- link --------------------------------- -->
                        <ng-container *ngSwitchCase="'link'">
                            <ng-container *ngIf="col.external; else routeTpl">
                                <a
                                    [href]="col.to"
                                    (click)="
                                        $any(col).action &&
                                            emit({
                                                action: $any(col).action,
                                                record: record
                                            })
                                    "
                                >
                                    {{
                                        (col.render
                                            ? (record | invoke : col.render)
                                            : record[col.name] || '-'
                                        ) | titlecase
                                    }}
                                </a>
                            </ng-container>
                            <ng-template #routeTpl>
                                <a
                                    [routerLink]="
                                        col.to && [record | invoke : col.to]
                                    "
                                    [queryParams]="resolveQueryParams(col, record)"
                                    (click)="
                                        $any(col).action &&
                                            emit({
                                                action: $any(col).action,
                                                record: record
                                            })
                                    "
                                >
                                    {{
                                        (col.render
                                            ? (record | invoke : col.render)
                                            : record[col.name] || '-'
                                        ) | titlecase
                                    }}
                                </a>
                            </ng-template>
                        </ng-container>

                        <!-- -------------------------------- date --------------------------------- -->
                        <ng-container *ngSwitchCase="'date'">
                            {{ record[col.name] | date : col.format }}
                        </ng-container>

                        <!-- ------------------------------- status -------------------------------- -->
                        <ng-container *ngSwitchCase="'status'">
                            <nz-tag
                                [nzColor]="
                                    col.statuses[record[col.name]]?.color
                                "
                            >
                                {{ col.statuses[record[col.name]]?.label }}
                            </nz-tag>
                        </ng-container>

                        <!-- -------------------------------- tags --------------------------------- -->
                        <ng-container *ngSwitchCase="'tags'">
                            <nz-tag
                                *ngFor="
                                    let tag of record | invoke : $any(col).tags
                                "
                            >
                                {{ tag }}
                            </nz-tag>
                        </ng-container>
                    </ng-container>
                </td>
            </ng-container>
        </ng-container>

        <td [nzAlign]="'center'" *ngIf="recordActions.length">
            <ng-container *ngFor="let action of recordActions; index as i">
                <ng-container
                    *ngIf="
                        !action.disabled || !(record | invoke : action.disabled)
                    "
                >
                    <nz-divider *ngIf="i" nzType="vertical"></nz-divider>
                    <ng-container *ngIf="action.external; else routerLinkTpl">
                        <a
                            [href]="record | invoke : action.to"
                            (click)="
                                emit({ action: action.name, record: record })
                            "
                        >
                            <i
                                nz-icon
                                class="md"
                                [nzType]="action.icon"
                                [nzTheme]="$any(action.theme || 'twotone')"
                                [nzTwotoneColor]="action.color || '#5CC4B6'"
                                [nzTooltipTitle]="action.title"
                                nz-tooltip
                            >
                            </i>
                        </a>
                    </ng-container>
                </ng-container>
                <ng-template #routerLinkTpl>
                    <a
                        *ngIf="!action.popup"
                        [routerLink]="
                            action.to ? [record | invoke : action.to] : null
                        "
                        [queryParams]="resolveQueryParams(action, record)"
                        (click)="emit({ action: action.name, record: record })"
                    >
                        <i
                            nz-icon
                            class="md"
                            [nzType]="action.icon"
                            [nzTheme]="$any(action.theme) || 'twotone'"
                            [nzTwotoneColor]="action.color || '#5CC4B6'"
                            [nzTooltipTitle]="action.title"
                            nz-tooltip
                        >
                        </i>
                    </a>

                    <!-- Action with confirm popups -->
                    <a
                        *ngIf="action.popup"
                        nz-popconfirm
                        [nzPopconfirmTitle]="
                            action.popupTitle || 'Are you sure?'
                        "
                        [nzPopconfirmPlacement]="
                            action.popupPlacement || 'bottom'
                        "
                        (nzOnConfirm)="
                            emit({ action: action.name, record: record })
                        "
                    >
                        <i
                            nz-icon
                            class="md"
                            [nzType]="action.icon"
                            [nzTheme]="$any(action.theme) || 'twotone'"
                            [nzTwotoneColor]="action.color || '#5CC4B6'"
                            [nzTooltipTitle]="action.title"
                            nz-tooltip
                        >
                        </i>
                    </a>
                </ng-template>
            </ng-container>
        </td>
    </tr>
</ng-template>
